import React, { useState, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { MultiSelect } from 'react-multi-select-component';
import Select from 'react-select';
import { Accordion, Card, Col, FormGroup, Row, Modal, Carousel, Button } from 'react-bootstrap';
import { cloneDeep, flatMap, isArray, isEmpty, unionBy, uniq } from 'lodash';
import { BombiixTagsInput } from '../../../Components/BombiixTagsInput';
import * as damAction from '../../Library/DamFolder/store/DamFolder.action';
import {
  customStylesProductAddEdit,
  getImageProperties,
  formatDuration,
  getProgressedVideoProperties,
  createOptions,
  checkArray,
  areArraysSimilar,
  capitalizeFirstLetter,
} from '../../../Components/helper';
import DamImageDropzone from './DamImageDropzone';
import Loader from '../../../Components/Utility/Loader/Loader';
import ImageVideoSelector from '../../../Components/ImgDropzone/imageSelector';
import { useDAMAddEditModuleState } from './Provider/index';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import ImageOrVideoLinkInput from './ImageOrVideoLinkInput';
import { fetchDamTag } from '../store/DAM.action';
import { fetchProductDamTag } from '../../DevlopmentOrder/Dam/DamFiles/store/DamFile.action';
import CustomToggle from '../../../Components/CustomToggle';
import { getSubBrandAccess } from '../../SystemMasters/Store/SystemMasters.action';

function AddEditDAMComponent({ errors, validationFun }) {
  const { t } = useTranslation('common');
  const reducer = useSelector((reducerstate) => reducerstate);
  const [showCustomAttr, setShowCustomAttr] = useState(false);
  const { ColorLibraryDetails, damModule, damFolderData, SystemMastersDetails } = reducer;
  const { ColorWaysLibList } = ColorLibraryDetails;
  const location = useLocation();
  const params = useParams();
  const { devOrderId } = params;
  const [currentFileIndex, setCarosuelIndex] = useState(0);
  const isDuplicate = location.pathname.includes('duplicate');
  const { damProductList, loader } = damModule;
  const { damFolderGroupList } = damFolderData;
  const { damAttributeDropdownList, damAttributeTextList } = SystemMastersDetails;
  const { DamAddeditstate, setAddEditDAMState } = useDAMAddEditModuleState();
  const { dam } = DamAddeditstate;
  const [state, setState] = useState({ folderOptionsList: [], showImageUploadModal: false, videoDownloadProgress: 0, tagsOptions: [] });
  const { showImageUploadModal, videoDownloadProgress, folderOptionsList } = state;
  const isFolderDragDrop = location?.state?.isFolderDragDrop || false;
  const [subBrandAccess, setSubBrandAccess] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchSubBrandAccess = async () => {
      const subBrandAccessRes = await dispatch(getSubBrandAccess());
      setSubBrandAccess(subBrandAccessRes?.data || false);
    };
    fetchSubBrandAccess();
  }, [dispatch]);

  useEffect(() => {
    if (damFolderGroupList?.length) {
      setState((prev) => ({
        ...prev,
        folderOptionsList: damFolderGroupList,
      }));
    } else {
      setState((prev) => ({
        ...prev,
        folderOptionsList: [],
      }));
    }
  }, [damFolderGroupList?.length]);

  const toggleImageModel = (i) => {
    setState((prev) => ({
      ...prev,
      showImageUploadModal: !prev.showImageUploadModal,
      imageIndex: i,
    }));
  };
  const productOptins = useMemo(() => {
    if (isArray(damProductList) && damProductList?.length > 0) {
      return damProductList.map((option) => ({ ...option, label: option?.number, value: option?._id }));
    }
    return [];
  }, [damProductList?.length]);

  const damFolderOptions = useMemo(() => {
    if (isArray(folderOptionsList) && folderOptionsList?.length > 0) {
      return folderOptionsList.map((option) => ({ ...option, label: option?.name, value: option?._id }));
    }
    return [];
  }, [folderOptionsList?.length]);

  useEffect(() => {
    if (isDuplicate) {
      const cloneDam = [...dam];
      const updatedDam = cloneDam?.map((item) => ({
        ...item,
        assetTitle: '',
        folder: [],
      }));
      setAddEditDAMState((prev) => ({
        ...prev,
        dam: updatedDam,
      }));
    }
  }, [isDuplicate]);

  const handleChange = (value, key, index) => {
    const cloneDam = [...dam];
    if (!value?.length && key === 'assignedTo' && devOrderId) {
      cloneDam[index].assignedTo = cloneDam[index]?.assignedTo.filter((data) => data?._id === devOrderId);
      setAddEditDAMState((prev) => ({
        ...prev,
        dam: cloneDam,
      }));
      return;
    }
    setState((prev) => ({
      ...prev,
      folderOptionsList: damFolderGroupList || [],
    }));
    cloneDam[index][key] = value;
    setAddEditDAMState((prev) => ({
      ...prev,
      dam: cloneDam,
    }));
  };

  const handleLinkImageUpload = async (src, index) => {
    const cloneDam = [...dam];
    cloneDam[index].imageLink = src || '';
    setAddEditDAMState((prev) => ({
      ...prev,
      dam: cloneDam,
    }));
    if (src) {
      getImageProperties(src)
        .then((properties) => {
          cloneDam[index].size = properties?.fileSize;
          cloneDam[index].fileType = properties?.fileType || 'image/jpeg';
          cloneDam[index].dimension = `${properties?.width}x${properties?.height}`;
          cloneDam[index].fileName = properties?.fileName || '';
          setAddEditDAMState((prev) => ({
            ...prev,
            dam: cloneDam,
          }));
        })
        .catch((err) => {
          cloneDam[index].size = '';
          cloneDam[index].fileType = '';
          cloneDam[index].dimension = '';
          cloneDam[index].fileName = '';
          cloneDam[index].croppedImage = '';
          cloneDam[index].imageUrl = '';
          cloneDam[index].imageLink = '';
          setAddEditDAMState((prev) => ({
            ...prev,
            dam: cloneDam,
          }));
          toasterMsg('Link is not valid', 'danger');
          validationFun(true, 0);
        });
    } else {
      cloneDam[index].size = '';
      cloneDam[index].fileType = '';
      cloneDam[index].dimension = '';
      cloneDam[index].fileName = '';
      cloneDam[index].croppedImage = '';
      cloneDam[index].imageUrl = '';
      cloneDam[index].imageLink = '';
      setAddEditDAMState((prev) => ({
        ...prev,
        dam: cloneDam,
      }));
    }
  };

  const onProgress = (loadTime) => {
    setState((prev) => ({
      ...prev,
      videoDownloadProgress: loadTime,
    }));
  };

  const handleLinkVideoUpload = async (src, index) => {
    setAddEditDAMState((prev) => ({
      ...prev,
      loaderVideo: true,
    }));
    const cloneDam = [...dam];
    cloneDam[index].videoLink = src || '';
    if (src) {
      getProgressedVideoProperties(src, onProgress)
        .then((properties) => {
          if (properties) {
            cloneDam[index].size = properties?.fileSize;
            cloneDam[index].fileType = properties?.fileType || 'video/mp4';
            cloneDam[index].duration = properties?.duration;
            cloneDam[index].videoThumbnail = properties?.thumbnail;
            cloneDam[index].fileName = properties?.fileName || '';
            setAddEditDAMState((prev) => ({
              ...prev,
              dam: cloneDam,
              loaderVideo: false,
            }));
          }
        })
        .catch((error) => {
          cloneDam[index].size = '';
          cloneDam[index].fileType = '';
          cloneDam[index].duration = '';
          cloneDam[index].videoThumbnail = '';
          cloneDam[index].fileName = '';
          cloneDam[index].croppedImage = '';
          cloneDam[index].imageUrl = '';
          cloneDam[index].videoLink = '';
          cloneDam[index].videoLinkType = null;
          cloneDam[index].imageLink = '';
          setAddEditDAMState((prev) => ({
            ...prev,
            dam: cloneDam,
            loaderVideo: false,
          }));
          toasterMsg('Link is not valid', 'danger');
        });
    } else {
      cloneDam[index].size = '';
      cloneDam[index].fileType = '';
      cloneDam[index].duration = '';
      cloneDam[index].videoThumbnail = '';
      cloneDam[index].fileName = '';
      cloneDam[index].croppedImage = '';
      cloneDam[index].imageUrl = '';
      cloneDam[index].videoLink = '';
      cloneDam[index].videoLinkType = null;
      cloneDam[index].imageLink = '';

      setAddEditDAMState((prev) => ({
        ...prev,
        dam: cloneDam,
        loaderVideo: false,
      }));
    }
  };

  const getOtherTags = async () => {
    let tagsData = [];
    if (devOrderId) {
      tagsData = await dispatch(fetchProductDamTag());
    } else {
      tagsData = await dispatch(fetchDamTag());
    }
    setState((prevData) => ({
      ...prevData,
      tagsOptions: createOptions(tagsData, 'name', 'id', true),
    }));
  };

  const updateDam = (value, key, index, labelId, isDropdown = true) => {
    const cloneDam = [...dam];
    const existingIndex = cloneDam[index][key].findIndex((item) => item?.lableId === labelId);

    if (value == null) {
      if (existingIndex !== -1) {
        cloneDam[index][key].splice(existingIndex, 1);
      }
    } else if (existingIndex !== -1) {
      // Replace existing object with the same lableId
      cloneDam[index][key][existingIndex] = isDropdown ? { lableId: labelId, optionId: value?._id } : { lableId: labelId, valueText: value };
    } else {
      // Add new object if no matching lableId is found
      cloneDam[index][key] = isDropdown
        ? [...cloneDam[index][key], { lableId: labelId, optionId: value?._id }]
        : [...cloneDam[index][key], { lableId: labelId, valueText: value }];
    }

    setAddEditDAMState((prev) => ({
      ...prev,
      dam: cloneDam,
    }));
  };

  const handleDropDown = (value, key, index, dropdown) => {
    updateDam(value, key, index, value?.lableId ? value?.lableId : dropdown?._id, true);
  };

  const handleText = (value, key, index, text) => {
    updateDam(value, key, index, text?._id, false);
  };
  const onAddition = (newTag, index) => {
    // Trim the new tag's name to check if it's just spaces
    const trimmedTag = newTag?.name?.trim();
    // If the trimmed tag is not empty, proceed to add it
    if (trimmedTag) {
      const cloneDam = [...dam];
      cloneDam[index].tags = [...cloneDam[index].tags, { ...newTag, name: trimmedTag }];
      setAddEditDAMState((prev) => ({
        ...prev,
        dam: cloneDam,
      }));
    }
  };

  const onDelete = (tagIndex, index) => {
    const cloneDam = [...dam];
    cloneDam[index].tags = cloneDam[index]?.tags?.filter((_, i) => i !== tagIndex);
    setAddEditDAMState((prev) => ({
      ...prev,
      dam: cloneDam,
    }));
  };

  const handleSelectCorousel = async (selectedIndex) => {
    const validation = await validationFun('undefined', currentFileIndex);
    const errorExistOnIndex = validation?.newErrors?.[currentFileIndex];
    if (isEmpty(errorExistOnIndex)) {
      setCarosuelIndex(selectedIndex);
    }
  };

  const handleOpenAccordion = () => {
    setShowCustomAttr(!showCustomAttr);
  };

  const handleImageUpload = async (fileUrl, croppedimage, dropZoneState, index, isVideoType, thumbnail) => {
    if (fileUrl) {
      const cloneDam = cloneDeep([...dam]);
      if (isVideoType && fileUrl?.includes('data:video')) {
        cloneDam[index].videoUrl = fileUrl;
        cloneDam[index].videoThumbnail = thumbnail;
        cloneDam[index].duration = dropZoneState.duration;
      } else if (fileUrl?.includes('data:image')) {
        cloneDam[index].imageUrl = fileUrl;
        cloneDam[index].croppedImage = croppedimage || fileUrl;
      }
      cloneDam[index].size = dropZoneState?.size || cloneDam.size;
      cloneDam[index].fileType = dropZoneState?.fileType || cloneDam.fileType;
      cloneDam[index].dimension = dropZoneState?.dimension || cloneDam.dimension;
      cloneDam[index].fileName = dropZoneState.fileName || cloneDam.fileName;
      setAddEditDAMState((prev) => ({
        ...prev,
        dam: cloneDam,
      }));
      setState((prev) => ({
        ...prev,
        showImageUploadModal: !prev.showImageUploadModal,
        imageIndex: 0,
      }));
    } else {
      toasterMsg('Please select a file', 'danger');
    }
  };

  const getAssetType = (assetType) => ['imageLink'].includes(assetType?.value);
  const getVideoAssetType = (assetType) => ['videoLink'].includes(assetType?.value);

  const getTextValue = (dynamicText, id) => {
    const TextData = dynamicText?.find((data) => data?.lableId === id);
    return TextData?.valueText;
  };

  const getDropDownValue = (dynamicDropdown, dropdown) => {
    const matchedDropdown = dynamicDropdown?.find((item) => item?.lableId === dropdown?._id);
    return dropdown?.options?.find((opt) => opt?._id === matchedDropdown?.optionId);
  };

  useEffect(() => {
    const reqparams = {
      isAllRecord: true,
    };
    dispatch(damAction.fetchDamFolderGroupList(reqparams));
  }, [dispatch]);

  const updateFolderList = (productTypeIds, brandIds) => {
    let cloneFolderList = damFolderGroupList;
    // Filter by productType
    if (productTypeIds.length && brandIds.length) {
      const brandProductTypebased = cloneFolderList?.filter((item) => {
        const matchesProductType = item?.productType?.some((pt) => productTypeIds?.includes(pt));
        const matchesBrand = item?.brand?.length === 0 || item?.brand?.some((b) => brandIds?.includes(b));
        return matchesProductType && matchesBrand;
      });
      cloneFolderList = unionBy(brandProductTypebased, '_id');
      cloneFolderList = cloneFolderList.map((option) => {
        return { ...option, label: option?.name, value: option?._id };
      });
    } else {
      const productTypeMatches = cloneFolderList.filter((item) => {
        return item?.productType?.some((pt) => productTypeIds.includes(pt));
      });
      cloneFolderList = unionBy(productTypeMatches, '_id');
      cloneFolderList = cloneFolderList.map((option) => {
        return { ...option, label: option?.name, value: option?._id };
      });
    }
    return cloneFolderList;
  };

  const updateAssignedToList = (productTypeIds, brandIds) => {
    let cloneAssignedtoList = productOptins;
    console.log('productTypeIdsproductTypeIds', productTypeIds);
    console.log('brandIdsbrandIds', brandIds);

    // Filter by productType
    if (productTypeIds.length && brandIds.length) {
      const brandMatches = cloneAssignedtoList.filter((item) => {
        return productTypeIds?.includes(item?.supplierType?._id) && brandIds?.includes(item?.brandId?._id);
      });
      cloneAssignedtoList = unionBy(brandMatches, '_id');
      cloneAssignedtoList = cloneAssignedtoList.map((option) => {
        return { ...option, label: option?.number, value: option?._id };
      });
    } else {
      const productTypeMatches = cloneAssignedtoList.filter((item) => {
        return productTypeIds?.includes(item?.supplierType?._id);
      });
      cloneAssignedtoList = unionBy(productTypeMatches, '_id');
      cloneAssignedtoList = cloneAssignedtoList.map((option) => {
        return { ...option, label: option?.number, value: option?._id };
      });
    }
    return cloneAssignedtoList;
  };
  const getFolderOptions = (assignedTo) => {
    const productTypes = [];
    const brands = [];
    const checkSimilarProducttype = [];
    const checKSimilarBrand = [];
    assignedTo?.forEach((element) => {
      if (element?.supplierType) {
        productTypes.push(element?.supplierType?._id);
        checkSimilarProducttype.push([element?.supplierType?._id]);
      }
      if (element?.brandId) {
        brands.push(element?.brandId?._id);
        checKSimilarBrand.push([element?.brandId?._id]);
      }
    });

    const checkProductTypeSimilar = areArraysSimilar(checkSimilarProducttype);
    const checkBrandSimilar = areArraysSimilar(checKSimilarBrand);
    if (!checkBrandSimilar || !checkProductTypeSimilar) {
      return [];
    }
    if (checkArray(assignedTo)) return updateFolderList(productTypes, brands);
    return damFolderOptions;
  };

  const getAssignedToOptions = (folder) => {
    let productTypesids = [];
    let brandsids = [];
    const checkSimilarProducttype = [];
    const checKSimilarBrand = [];
    folder?.forEach((element) => {
      if (element?.productType?.length) {
        productTypesids.push(element?.productType);
        checkSimilarProducttype.push(element?.productType);
      }
      if (element?.brand?.length) {
        brandsids.push(element?.brand);
        checKSimilarBrand.push(element?.brand);
      }
    });
    const checkProductTypeSimilar = areArraysSimilar(checkSimilarProducttype);
    const checkBrandSimilar = areArraysSimilar(checKSimilarBrand);

    if (!checkBrandSimilar || !checkProductTypeSimilar) {
      return [];
    }
    productTypesids = flatMap(productTypesids);
    brandsids = flatMap(brandsids);
    if (checkArray(folder)) return updateAssignedToList(uniq(productTypesids), uniq(brandsids));
    return productOptins;
  };

  const disableIfProductExist = (options) => {
    if (devOrderId) {
      return options?.map((option) => ({
        ...option,
        disabled: option?._id === devOrderId,
      }));
    }
    return options;
  };

  useEffect(() => {
    if (devOrderId && productOptins?.length > 0 && dam?.length > 0) {
      const devOrderOption = productOptins?.find((option) => option?._id === devOrderId);
      const cloneDam = dam?.map((vl) => {
        const cloneObj = { ...vl };
        if (cloneObj.assignedTo?.length === 0) {
          cloneObj.assignedTo = [...vl.assignedTo, devOrderOption];
        }
        return cloneObj;
      });
      setAddEditDAMState((prev) => ({
        ...prev,
        dam: cloneDam,
      }));
    }
  }, [devOrderId, productOptins?.length, dam?.length, setAddEditDAMState]);
  return (
    <div className="add-edit-dam-container h-100">
      {loader ? (
        <Loader />
      ) : (
        <Carousel
          controls={dam?.length > 1}
          interval={null}
          activeIndex={currentFileIndex}
          onSelect={handleSelectCorousel}
          nextIcon={<span className="carousel-control-next-icon" aria-hidden="true" style={{ color: '#000000', backgroundColor: '#000000' }} />}
          prevIcon={<span className="carousel-control-prev-icon" aria-hidden="true" style={{ color: '#000000', backgroundColor: '#000000' }} />}
        >
          {dam?.map((val, i) => {
            const {
              croppedImage,
              assetType,
              assetTitle,
              assignedTo,
              size,
              dimension,
              fileType,
              colourTheme,
              primaryColour,
              secondaryColour,
              folder,
              description,
              tags,
              imageUrl,
              imageLink,
              dynamicText,
              dynamicDropdown,
              duration,
              videoUrl,
              videoLink,
              videoThumbnail,
              videoLinkType,
            } = val;
            const isImageLink = getAssetType(assetType);
            const isVideoType = assetType?.value === 'video';
            const isVideoLink = getVideoAssetType(assetType);
            const folderOptions = getFolderOptions(val?.assignedTo || []);
            const assignedToOptions = getAssignedToOptions(val?.folder || []);

            return (
              <Carousel.Item key={i}>
                <div className="main-details-block">
                  <ImageVideoSelector
                    handleImageUpload={() => toggleImageModel(i)}
                    t={t}
                    data={{
                      image: croppedImage || imageUrl || imageLink,
                      video: videoUrl || videoLink,
                      thumbnailImage: videoThumbnail,
                    }}
                    isUploadBtn={!isImageLink && !isVideoLink && !isFolderDragDrop}
                    isFromLink={isImageLink || isVideoLink}
                    isVideoType={isVideoLink ? true : isVideoType}
                  />
                  <Row className="flex-fill">
                    <ImageOrVideoLinkInput
                      isImageLink={isImageLink}
                      isVideoLink={isVideoLink}
                      handleLinkImageUpload={handleLinkImageUpload}
                      handleLinkVideoUpload={handleLinkVideoUpload}
                      i={i}
                      imageLink={imageLink}
                      videoLink={videoLink}
                      errors={errors}
                      t={t}
                      progress={videoDownloadProgress}
                      loaderVideo={DamAddeditstate.loaderVideo}
                      handleVideoLinkTypeChange={(value) => handleChange(value, 'videoLinkType', i)}
                      videoLinkType={videoLinkType}
                    />
                    <Col md={isImageLink || isVideoLink ? 4 : 6}>
                      <FormGroup>
                        <div className="input-group form-floating-label fixed-label">
                          <input
                            type="text"
                            onChange={(e) => handleChange(e?.target?.value, 'assetTitle', i)}
                            name="code"
                            className="form-control"
                            value={assetTitle}
                            placeholder={t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.ASSET_TITLE_PLACEHOLDER')}
                          />
                          <label className="asterisk-req">
                            {t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.ASSET_TITLE')}
                            <span>*</span>
                          </label>
                        </div>
                        {errors?.[i]?.assetTitle && <span className="error-message">{errors?.[i]?.assetTitle}</span>}
                      </FormGroup>
                    </Col>
                    <Col md={isImageLink || isVideoLink ? 4 : 6}>
                      <FormGroup>
                        <label className="select-label">{t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.ASSIGNED_TO')}</label>
                        <div className="custom-react-select ">
                          <MultiSelect
                            hasSelectAll
                            name="products"
                            disabled={devOrderId}
                            options={disableIfProductExist(assignedToOptions)}
                            className="custom-multiselect"
                            labelledBy={t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.SELECT_PRODUCTS')}
                            value={assignedTo}
                            onChange={(e) => handleChange(e, 'assignedTo', i)}
                          />
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                </div>

                <Row>
                  <Col md={2}>
                    <FormGroup>
                      <div className="input-group form-floating-label fixed-label">
                        <input
                          readOnly
                          type="text"
                          name="description"
                          maxLength={200}
                          className="form-control"
                          value={`${size} ${size !== 'N/A' ? 'MB' : ''}`}
                        />
                        <label className="asterisk-req"> {t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.SIZE')}</label>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col md={2}>
                    <FormGroup>
                      {isVideoType || isVideoLink ? (
                        <div className="input-group form-floating-label fixed-label">
                          <input readOnly type="text" name="description" maxLength={200} className="form-control" value={formatDuration(duration)} />
                          <label className="asterisk-req"> {t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.DURATION')}</label>
                        </div>
                      ) : (
                        <div className="input-group form-floating-label fixed-label">
                          <input readOnly type="text" name="description" maxLength={200} className="form-control" value={dimension} />
                          <label className="asterisk-req"> {t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.DIMENSIONS')}</label>
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={2}>
                    <FormGroup>
                      <div className="input-group form-floating-label fixed-label">
                        <input readOnly type="text" name="description" maxLength={200} className="form-control" value={capitalizeFirstLetter(fileType)} />
                        <label className="asterisk-req"> {t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.FILE_TYPE')}</label>
                      </div>
                    </FormGroup>
                  </Col>

                  <Col md={2}>
                    <FormGroup>
                      <div className="custom-react-select">
                        <label className="asterisk-req f-13 m-0">{t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.COLOUR_THEME')}</label>
                        <Select
                          options={ColorWaysLibList || []}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option._id}
                          styles={customStylesProductAddEdit}
                          placeholder={t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.COLOUR_THEME_PLACEHOLDER')}
                          isClearable
                          value={colourTheme}
                          onChange={(e) => handleChange(e, 'colourTheme', i)}
                        />
                      </div>
                    </FormGroup>
                  </Col>

                  <Col md={2}>
                    <FormGroup>
                      <div className="custom-react-select">
                        <label className="asterisk-req f-13 m-0">{t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.PRIMARY_COLOUR')}</label>
                        <Select
                          options={ColorWaysLibList || []}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option._id}
                          styles={customStylesProductAddEdit}
                          placeholder={t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.PRIMARY_COLOUR_PLACEHOLDER')}
                          isClearable
                          value={primaryColour}
                          onChange={(e) => handleChange(e, 'primaryColour', i)}
                        />
                      </div>
                    </FormGroup>
                  </Col>

                  <Col md={2}>
                    <FormGroup>
                      <div className="custom-react-select">
                        <label className="asterisk-req f-13 m-0">{t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.SECONDARY_COLOUR')}</label>
                        <Select
                          options={ColorWaysLibList || []}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option._id}
                          styles={customStylesProductAddEdit}
                          placeholder={t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.SECONDARY_COLOUR_PLACEHOLDER')}
                          isClearable
                          value={secondaryColour}
                          onChange={(e) => handleChange(e, 'secondaryColour', i)}
                        />
                      </div>
                    </FormGroup>
                  </Col>

                  {damAttributeDropdownList?.length > 0 &&
                    damAttributeDropdownList?.map(
                      (dropdown) =>
                        dropdown?.isActive && (
                          <Col md={2} key={dropdown?._id}>
                            <FormGroup>
                              <div className="custom-react-select">
                                <label className="asterisk-req f-13 m-0">{dropdown?.keyName}</label>
                                <Select
                                  options={dropdown?.options?.filter((option) => option?.isActive) || []}
                                  getOptionLabel={(option) => option.keyName}
                                  getOptionValue={(option) => option._id}
                                  styles={customStylesProductAddEdit}
                                  placeholder="Custom Dropdown"
                                  isClearable
                                  onChange={(e) => handleDropDown(e, 'dynamicDropdown', i, dropdown)}
                                  value={getDropDownValue(dynamicDropdown, dropdown)}
                                  maxMenuHeight={140}
                                />
                              </div>
                            </FormGroup>
                          </Col>
                        ),
                    )}

                  {damAttributeTextList?.length > 0 &&
                    damAttributeTextList?.map(
                      (text) =>
                        text?.isActive && (
                          <Col md={2} key={text?._id}>
                            <FormGroup>
                              <div className="input-group form-floating-label fixed-label">
                                <input
                                  type="text"
                                  onChange={(e) => handleText(e?.target?.value, 'dynamicText', i, text)}
                                  name="dynamicText"
                                  disabled={!text?.textFieldConfig?.isEditable}
                                  className="form-control"
                                  placeholder="Custom Text"
                                  value={getTextValue(dynamicText, text?._id)}
                                  maxLength={text?.textFieldConfig?.charLimit}
                                />
                                <label className="asterisk-req f-13 m-0">{text?.keyName}</label>
                              </div>
                            </FormGroup>
                          </Col>
                        ),
                    )}

                  <Col md={2}>
                    <FormGroup>
                      <div className="custom-react-select">
                        <label className="asterisk-req f-13 m-0">{t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.FOLDER')}</label>
                        <MultiSelect
                          hasSelectAll
                          name="products"
                          options={folderOptions}
                          className="custom-multiselect"
                          labelledBy={t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.SELECT_PRODUCTS')}
                          value={folder}
                          onChange={(e) => handleChange(e, 'folder', i)}
                        />
                      </div>
                    </FormGroup>
                  </Col>

                  <Col md={2}>
                    <FormGroup>
                      <div className="input-group form-floating-label fixed-label">
                        <input type="text" readOnly name="description" maxLength={200} className="form-control" value={assetType?.label} />
                        <label className="asterisk-req"> {t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.ASSET_TYPE')}</label>
                      </div>
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup>
                      <div className="input-group form-floating-label fixed-label">
                        <input
                          type="text"
                          onChange={(e) => handleChange(e.target.value, 'description', i)}
                          name="description"
                          maxLength={200}
                          className="form-control"
                          value={description}
                        />
                        <label className="asterisk-req"> {t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.DESCRIPTION')}</label>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col md={12}>
                    <FormGroup className="dam-react-tags">
                      <BombiixTagsInput
                        tags={tags}
                        allowNew
                        placeholderText="Add a tag"
                        onDelete={(vals) => onDelete(vals, i)}
                        onAddition={(vals) => onAddition(vals, i)}
                        suggestions={state?.tagsOptions}
                        onFocus={getOtherTags}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                {assignedTo?.map((products) => {
                  const { sizeRanges, number, brandId, catOneId, catTwoId, catThreeId, catFourId, gradingGroups, supplierType, subBrandId } = products;
                  const gradingValue = gradingGroups
                    ?.map((obj) => {
                      const filteredArr1 = obj?.sizeRanges?.filter((item) => sizeRanges?.includes(item?.name));
                      const sizeRangeNames = filteredArr1?.map((range) => range.name).join(',');
                      return `${obj.name} - ${sizeRangeNames}`;
                    })
                    .join(', ');
                  return (
                    <Row className="collapse-card" key={products?._id}>
                      <Col md={12}>
                        <Accordion defaultActiveKey="0">
                          <Card className="mb-3">
                            <Card.Header>
                              <span className="f-16">{number}</span>
                              <Accordion.Toggle
                                className="text-decoration-none btn-toggle"
                                as={Button}
                                eventKey="0"
                                variant="link"
                                onClick={() => handleOpenAccordion()}
                              >
                                <CustomToggle eventKey="0" isDefaultActive />
                              </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey="0">
                              <Card.Body>
                                <Row>
                                  <Col md={3}>
                                    <FormGroup>
                                      <div className="input-group form-floating-label fixed-label">
                                        <input type="text" name="description" maxLength={200} className="form-control" value={supplierType?.name} readOnly />
                                        <label className="asterisk-req" htmlFor="descriptionInput">
                                          {t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.PRODUCT_TYPE')}
                                        </label>
                                      </div>
                                    </FormGroup>
                                  </Col>
                                  <Col md={3}>
                                    <FormGroup>
                                      <div className="input-group form-floating-label fixed-label">
                                        <input type="text" name="description" maxLength={200} className="form-control" value={brandId?.name} readOnly />
                                        <label className="asterisk-req" htmlFor="descriptionInput">
                                          {t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.BRAND')}
                                        </label>
                                      </div>
                                    </FormGroup>
                                  </Col>
                                  {subBrandAccess && (
                                    <Col md={3}>
                                      <FormGroup>
                                        <div className="input-group form-floating-label fixed-label">
                                          <input type="text" name="description" maxLength={200} className="form-control" value={subBrandId?.name} readOnly />
                                          <label className="asterisk-req" htmlFor="descriptionInput">
                                            {t('SUB_BRAND.SUBBRAND')}
                                          </label>
                                        </div>
                                      </FormGroup>
                                    </Col>
                                  )}
                                  <Col md={3}>
                                    <FormGroup>
                                      <div className="input-group form-floating-label fixed-label">
                                        <input type="text" name="description" maxLength={200} className="form-control" value={catOneId?.name} readOnly />
                                        <label className="asterisk-req" htmlFor="descriptionInput">
                                          {t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.CATEGORY1')}
                                        </label>
                                      </div>
                                    </FormGroup>
                                  </Col>
                                  <Col md={3}>
                                    <FormGroup>
                                      <div className="input-group form-floating-label fixed-label">
                                        <input type="text" name="description" maxLength={200} className="form-control" value={catTwoId?.name} readOnly />
                                        <label className="asterisk-req" htmlFor="descriptionInput">
                                          {t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.CATEGORY2')}
                                        </label>
                                      </div>
                                    </FormGroup>
                                  </Col>
                                  <Col md={3}>
                                    <FormGroup>
                                      <div className="input-group form-floating-label fixed-label">
                                        <input type="text" name="description" maxLength={200} className="form-control" value={catThreeId?.name} readOnly />
                                        <label className="asterisk-req" htmlFor="descriptionInput">
                                          {t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.CATEGORY3')}
                                        </label>
                                      </div>
                                    </FormGroup>
                                  </Col>
                                  <Col md={3}>
                                    <FormGroup>
                                      <div className="input-group form-floating-label fixed-label">
                                        <input type="text" name="description" maxLength={200} className="form-control" value={catFourId?.name} readOnly />
                                        <label className="asterisk-req" htmlFor="descriptionInput">
                                          {t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.CATEGORY4')}
                                        </label>
                                      </div>
                                    </FormGroup>
                                  </Col>
                                  <Col md={6}>
                                    <FormGroup>
                                      <div className="input-group form-floating-label fixed-label">
                                        <input type="text" name="description" maxLength={200} className="form-control" value={gradingValue} readOnly />
                                        <label className="asterisk-req" htmlFor="descriptionInput">
                                          {t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.GRADING_GROUP')}
                                        </label>
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        </Accordion>
                      </Col>
                    </Row>
                  );
                })}
                {showImageUploadModal && (
                  <Modal className="custom-modal modal-large supplier-overview-modal" size="md" show backdrop="static" centered>
                    <Modal.Header>
                      <Modal.Title>
                        <span>{t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.UPLOAD_IMAGE')}</span>
                      </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <div className="modal-body">
                        <DamImageDropzone
                          title={
                            assetType?.value === 'video'
                              ? t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.UPLOAD_PAGE_VIDEO_TITLE')
                              : t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.UPLOAD_PAGE_IMAGE_TITLE')
                          }
                          acceptFileTypes={assetType?.value === 'video' ? '.mp4, .webm, .mov' : 'image/jpeg, image/png, image/webp, .jpeg, .jpg, .png, .webp'}
                          imageUrl={dam?.[i]?.imageUrl || dam?.[i]?.croppedImage || ''}
                          onSubmit={handleImageUpload}
                          onClose={() => setState((prev) => ({ ...prev, showImageUploadModal: false }))}
                          fileIndex={i}
                          isVideoType={assetType?.value === 'video'}
                          isImageType={assetType?.value === 'image'}
                          editModeUrls={{ ...dam?.[i], imageUrl, videoUrl, videoThumbnail }}
                          cropSize="FREE"
                          translate={t}
                        />
                      </div>
                    </Modal.Body>
                  </Modal>
                )}
              </Carousel.Item>
            );
          })}
        </Carousel>
      )}
    </div>
  );
}

export default AddEditDAMComponent;
